// Call to Action Types
export const CALL_TO_ACTION_TYPES = {
  REQUEST_INFORMATION_CALL: 'request_information_call',
  HIRE_AT_NO_COST: 'hire_at_no_cost',
  HIRE: 'hire'
};
